export default __webpack_public_path__ + "media/flags/im-685ca372.svg";